import { createRouter, createWebHashHistory } from 'vue-router'
import request from '@/utils/request'
import { ElMessage, } from 'element-plus'
import { useUserStore } from '@/stores/user'

const routes = [
  { path: '/', redirect: '/login' },
	{ path: '/login', name: 'UserLogin', component: () => import('../views/UserLogin.vue') },
	{ 
    path: '/home', 
    name: 'HomePage', 
    component: () => import('../views/HomePage.vue'),
    children: [
      {
        path: '/my',
        name: 'MyPage',
        component: () => import('../views/MyPage.vue')
      },
      {
        path: '/test/main',
        name: 'TestMain',
        component: () => import('../views/TestMain.vue')
      },
      {
        path: '/test/preview',
        name: 'TestPreview',
        component: () => import('../views/TestPreview.vue')
      },
      {
        path: '/test/result',
        name: 'TestResult',
        component: () => import('../views/TestResult.vue')
      },
    ]
  },
  {
    path: '/test/intro',
    name: 'TestIntro',
    component: () => import('../views/TestIntro.vue')
  },
  {
    path: '/test/mock',
    name: 'TestMock',
    component: () => import('../views/TestMock.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_PUBLIC_PATH),  // 使用 hash 模式
  routes
})

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 白名单路径不需要鉴权
  const whiteList = ['/login']
  // console.log(to.path)
  if (whiteList.includes(to.path)) {
    // console.log(to.path)
    return next()
  }
  if (from.path === '/test/mock' && to.path === '/test/result') {
    return next()
  }

  try {
    const userInfoStr = sessionStorage.getItem('web_userinfo')
    if (userInfoStr) {
      const userInfo = JSON.parse(userInfoStr)
      const userId = userInfo.userId
      const res = await request.api.get("/wapsPay/Login/pthTest/v3/web/device.do", {
        params: {
          userId: userId
        }
      })
      if (res.data.code == 200) {
        const res1 = await request.api.get("/wapsPay/Login/pthTest/v3/getInfo.do", {
          params: {
            userId: userId
          }
        })
        // console.log(res1.data)
        // 更新打卡日期和会员状态
        if (res1.data.code == 200 && res1.data.data) {
          userInfo.signDate = res1.data.data.signDate
          userInfo.vipType = res1.data.data.vipType
          sessionStorage.setItem('web_userinfo', JSON.stringify(userInfo))

          // 更新 store 状态
          const userStore = useUserStore()
          // userStore.updateUserInfo({
          //   signDate: res1.data.data.signDate,
          //   vipType: res1.data.data.vipType
          // })
          userStore.updateUserInfo(res1.data.data)
        }

        next() // 成功，继续导航
      } else {
        ElMessage.info('账号已在其他设备上登录')
        // localStorage.removeItem('web_access_token')
        sessionStorage.removeItem('web_userinfo')
        next('/login') // 失败，跳转到登录页
      }
    } else {
      next('/login')
    }
  } catch (error) {
    console.error('error:', error)
    next('/login') // 出错也跳转到登录页
  }
})

export default router